export default __webpack_public_path__ + "alberta-note.51f4e80c43fe1a9ce41c.svg";